//#region Angular Imports

import { StateService } from "@uirouter/angularjs";

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { MeasurementsBridge } from '../common/measurements/measurements.controller'
import { MeasurementModel } from "../api/api.models"
import { LoggerService } from './../common/common.module'
import { i18n } from '../common/i18n/common.i18n'
import { CommonHelper, DataType, ViewColumnType } from '../../helpers/common-helper'
import { Permissions } from '../../helpers/permissions'
import { OperatorLayoutSettings } from '../../helpers/operator-layout-settings'
import { IMRBaseControlDirectiveController } from '../common/base'

interface KPIScope extends ng.IScope {
    measurementsBridge: MeasurementsBridge
    isLoading: boolean
}

export class KPIController extends IMRBaseControlDirectiveController {
    static KPI_SELECTED_LOCATIONS = "KPI_SELECTED_LOCATIONS"
    static KPI_SELECTED_METERS = "KPI_SELECTED_METERS"

    permissions: any;
    measurementsData: MeasurementModel[];

    constructor(protected $scope: KPIScope, protected $state: StateService, protected $q: ng.IQService, protected api: Api, private logger: LoggerService, private localDictionary: LocalDictionaryFactory) {
        super()
        this.buildBridges();
    }

    buildBridges() {
        this.$scope.$root.$broadcast('disableLoadingIndicator')
        this.$scope.isLoading = true

        var selectedLocationsIds: number[] = OperatorLayoutSettings.getSetting(KPIController.KPI_SELECTED_LOCATIONS, [])
        var selectedMetersIds: number[] = OperatorLayoutSettings.getSetting(KPIController.KPI_SELECTED_METERS, [])

        this.localDictionary.getPromise().then(() => {
            let idMeter = this.localDictionary.getViewColumnName(CommonHelper.IdMeter, DataType.HELPER_ID_METER, ViewColumnType.BaseHelper);
            if (idMeter) {
                let idLocation = this.localDictionary.getViewColumnName(CommonHelper.IdLocation, DataType.HELPER_ID_LOCATION, ViewColumnType.BaseHelper);
                if (idLocation) {
                    var promisesArray: any[] = [this.api.kpi.getAggregationPeriods()]

                    if (selectedLocationsIds.length > 0) {
                        promisesArray.push(this.localDictionary.getLocationsKPI(5000, 1, idLocation + " in (" + selectedLocationsIds.join(',') + ')').then(result => result.values))
                    } else {
                        promisesArray.push([])
                    }

                    if (selectedMetersIds.length > 0) {
                        promisesArray.push(this.localDictionary.getMetersKPI(5000, 1, idMeter + " in (" + selectedMetersIds.join(',') + ')').then(result => result.values))
                    } else {
                        promisesArray.push([])
                    }

                    var promises: ng.IPromise<any[]> = this.$q.all(promisesArray)

                    promises.then(data => {
                        var aggregationPeriods = data[0]
                        var selectedLocations = data[1]
                        var selectedMeters = data[2]

                        this.$scope.isLoading = false

                        this.$scope.measurementsBridge = {
                            id: 1,
                            latestDataMethodName: 'getMeasurementsKPI',
                            dataMethodName: 'getMeasurementsKPI',
                            requestProperty: 'locationIds',
                            data: () => {
                                return this.measurementsData;
                            },
                            dataCallback: data => {
                                this.measurementsData = data;
                            },
                            aggregationPeriods: aggregationPeriods.result,
                            groups: selectedLocations,
                            meters: selectedMeters,
                            chartOptionsPermissions: [Permissions.KPI_MODULE_CHART_OPTION_HIDDEN],
                            chartDataTypeOptionsPermissions: [Permissions.KPI_MODULE_CHART_DATA_TYPE_OPTION_HIDDEN]
                        }
                    })

                    promises.catch(reason => {
                        CommonHelper.openInfoPopup(i18n("Common", "WebServiceException"), "error");
                        this.logger.log(reason);
                    })

                    promises.finally(() => {
                        this.$scope.isLoading = false
                        this.$scope.$root.$broadcast('enableLoadingIndicator')
                    })
                }
            }
        })
    }
}